import Loadable from "react-loadable";
import { Loading } from "../../common/navigation";

const Notices = Loadable({
  loader: () => import("./components/notices"),
  loading: Loading
});

const NoticeDetails = Loadable({
  loader: () => import("./components/notice_details"),
  loading: Loading
})

export const routes = [
  {
    path: '/notices',
    exact: true,
    name: 'notices',
    component: Notices,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  },
  {
    path: '/notices/notice_details/:id',
    exact: true,
    name: 'notices details',
    component: NoticeDetails,
    // "permission": {
    //   "contactype": [
    //     "affiliate",
    //     "student",
    //     "faculty"
    //   ],
    //   "group": [

    //   ]
    // },
  }
];

// export * from './noticesActions';
// export * from './noticesReducer';